import React from 'react';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMConst from 'lib/SMConst';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMGuideAppDownload from 'components/reservations/SMGuideAppDownload';

class SMRoomInquirySentView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      mailUrl: "",
      fbUrl: "",
      lineUrl: "",
    };
  }

  componentDidMount(){
    const room = this.props.reservation.room;
    this.setState({
      mailUrl: SMAppHelper.shareRoomMailUrl(room),
      fbUrl: SMAppHelper.shareRoomFacebookMessageUrl(room),
      lineUrl: SMAppHelper.shareRoomLineUrl(room),
    });
  }

  render() {
    const reservation = this.props.reservation;
    const room = reservation.room;
    const replyMessage = reservation.method == SMConst.ReservationMethod.Concierge ? "ホストまたはスペースマーケットからの返信をお待ちください。" : "ホストからの返信をお待ちください。";

    return(
      <div className="site-main">
        <div className="page__even page__padding">
          <div className="container">
            <div className="page-xs12-head">
              <h1 className="page-title">お問い合わせを送信しました</h1>
              <p className="page-description">{replyMessage}</p>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-5">
                <div className="site-sidebar">
                  <a href={Routes.space_room_path(room.space.username, room.uid)}>
                    <div className="side-space__units">
                      <img src={SMFormatHelper.roomImageURL(room, {width: 1200, height: 670})} alt="" />
                      <h2 className="side-space__units-title">{SMFormatHelper.roomName(room)}</h2>
                    </div>
                  </a>
                </div>
                <div className="complete-social mb30">
                  <p className="ta-c complete-social__title">このスペースをシェアする</p>
                  <ul className="row complete-social__list">
                    {/* <li className="col-xs-4">
                      <a href="#" className="social-link__mail"><i className="fa fa-twitter"></i></a>
                    </li> */}
                    <li className="col-xs-4">
                      <a href={this.state.mailUrl} className="social-link__mail"><i className="fa fa-envelope"></i></a>
                    </li>
                    <li className="col-xs-4">
                      <a href={this.state.fbUrl} className="social-link__facebook"><i className="fa fa-facebook-square"></i></a>
                    </li>
                    <li className="col-xs-4">
                      <a href={this.state.lineUrl} target="_blank" className="social-link__line"><i className="icon-spm-line"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-sm-12 col-md-7">
                <p className="contact__complete-text">追加でメッセージを送りたい場合は、お問い合わせ詳細ページより送ることができます。</p>
                <div className="complete-detail__btn contact__complete-detail">
                  <p className="mb20">最新のメッセージから3日間が経過した場合またはゲストがメッセージを終了した場合、メッセージの送信ができなくなります。ご注意ください。</p>
                  <a href={Routes.dashboard_reservation_path(reservation.uid)} className="button-blue pt15 pb15 w200">お問い合わせ詳細へ</a>
                </div>
              </div>
            </div>
            <SMGuideAppDownload />
          </div>
        </div>
      </div>
    );
  }

}
export default SMRoomInquirySentView;



// WEBPACK FOOTER //
// ./app/javascript/components/rooms/SMRoomInquirySentView.jsx